import request from 'superagent';
import url from '../../utils/url';
import * as actionTypes from '../actionTypes/clientCodeActionTypes';
import { notify } from '../../components/common/Notification';

export const getClientCodes = (searchStr = '') => dispatch => {
  const query_str = `query=${searchStr}&page=1`;

  dispatch({
    type: actionTypes.CLIENT_CODE_LIST.REQUEST,
  });

  const onSuccess = response =>
    dispatch({
      type: actionTypes.CLIENT_CODE_LIST.SUCCESS,
      resBody: response.body.data,
      hasMadeRequest: false,
    });

  const onFail = () =>
    dispatch({
      type: actionTypes.CLIENT_CODE_LIST.ERROR,
    });

  return request
    .get(url(`/clientcode/get-codes?${query_str}`))
    .set('Content-Type', 'application/json')
    .then(onSuccess, onFail);
};

export function savedCodes(response, param) {
  // Nothing returned here
  return {
    type: actionTypes.CLIENT_CODE_SET.SUCCESS,
    code: param,
  };
}

export const setClientCode = params => dispatch => {
  dispatch({
    type: actionTypes.CLIENT_CODE_SET.REQUEST,
  });

  const onFailure = () =>
    dispatch({
      type: actionTypes.CLIENT_CODE_SET.ERROR,
    });

  return request
    .post(url('/clientcode/set'))
    .type('form')
    .send({ code: params })
    .then(response => {
      window.Drupal.settings.clientCode = params || '';
      dispatch(savedCodes(response, params));
    }, onFailure);
};

export const hasValidClientCode = () => dispatch => {
  if (window.client_code_is_valid && !window.client_code_is_valid()) {
    notify.error('Please set a valid Client Code');

    dispatch({ type: actionTypes.CLIENT_CODE_VALIDATION_ERROR });
    return false;
  }

  dispatch({ type: actionTypes.CLIENT_CODE_VALIDATION_SUCCESS });
  return true;
};



// WEBPACK FOOTER //
// ./src/redux/actions/clientCodeAction.js